import { writable } from 'svelte/store';
import type { LottieUID } from '../types';

export const triggeredUIDs = createTriggeredUIDsStore();
function createTriggeredUIDsStore() {
  const { subscribe, update } = writable<Map<string, LottieUID[]>>(new Map());

  return {
    subscribe,
    add(uid: LottieUID, animationName: string) {
      update((uids) => {
        if (uids.has(animationName)) {
          const uidsForAnimation = uids.get(animationName) || [];
          uidsForAnimation.push(uid);
          uids.set(animationName, uidsForAnimation);
          return uids;
        }
        uids.set(animationName, [uid]);
        return uids;
      });
    },
    exist(uid: LottieUID, animationName: string) {
      let exist = false;
      update((uids) => {
        const uidsForAnimation = uids.get(animationName) || [];
        if (uidsForAnimation.includes(uid)) {
          exist = true;
          return uids;
        }
        return uids;
      });

      return exist;
    },
  };
}
